
const GroupManageModel = function () {
    const name = 'GroupManage';
    return {
        name,
        state: {
            condition: {
                // mchNo: '',
                name: '',
                // type: '',
            },
            newGroupData:{
                name:'',
                // mchNo:'',
                // type:'',
                permissions:[],
            },
            editGroupData:{
                name:'',
                // mchNo:'',
                // type:'',
                permissions:[],
            },
            userList:{
                name:'',
                status:'',
            },
            page: {
                pageSize: 10,
                current: 1,
                total: 0,
            },
            userPage: {
                pageSize: 10,
                current: 1,
                total: 0,
            },
            newPerCondition:{
                code:'',
                name:'',
                app:'',
                type:'',
                path:'',
                idx:'',
                parentCode:'',
            },
            uList:[],
            editParentGroupData:{
                name:'',
                parentpermissions:[],
            },
        },
        selectors: (state, props) => {
            const currentState = state[name];
            const selectors = {
                getCondition: () => currentState.condition,
                getNewGroupData: () => currentState.newGroupData,
                getEditGroupData: () => currentState.editGroupData,
                getUserList: () => currentState.userList,
                getUList: () => currentState.uList,
                getNewPerCondition: ()=> currentState.newPerCondition,
                getPage: () => currentState.page,
                getUserPage: () => currentState.userPage,
                getEditParentGroupData: ()=>currentState.editParentGroupData,
            };
            return selectors;
        },
        api: {},
        actions: {
            changeCondition: (key, value) => (dispatch, getState) => {
                dispatch({
                    type: 'CHANGE_CONDITION',
                    key,
                    value
                })
            },
            changeNewGroupData: (key, value) => (dispatch, getState) => {
                dispatch({
                    type: 'CHANGE_NEW_GROUP_DATA',
                    key,
                    value
                })
            },
            changeEditGroupData: (key, value) => (dispatch, getState) => {
                dispatch({
                    type: 'CHANGE_EDIT_GROUP_DATA',
                    key,
                    value
                })
            },
            changeUserList: (key, value) => (dispatch, getState) => {
                dispatch({
                    type: 'CHANGE_USER_LIST',
                    key,
                    value
                })
            },
            changeNewPerCondition: (key, value) => (dispatch, getState) => {
                dispatch({
                    type: 'CHANGE_NEW_PER_CONDITION',
                    key,
                    value
                })
            },
            changeUList: (list) => (dispatch, getState) => {
                dispatch({
                    type: 'CHANGE_U_LIST',
                    list
                })
            },
            changePage: (page) => (dispatch, getState) => {
                dispatch({
                    type: 'CHANGE_PAGE',
                    page
                })
            },
            changeUserPage: (page) => (dispatch, getState) => {
                dispatch({
                    type: 'CHANGE_USER_PAGE',
                    page
                })
            },
            changeParentEditGroupData: (key, value) => (dispatch, getState) => {
                dispatch({
                    type: 'CHANGE_PARENT_EDIT_GROUP_DATA',
                    key,
                    value
                })
            },
        },
        reducers: {
            page: (state = GroupManageModel.state.page, action) => {
                if (action.type === 'CHANGE_PAGE') {
                  return Object.assign({}, state, action.page);
                }
                return state;
            },
            userPage: (state = GroupManageModel.state.userPage, action) => {
                if (action.type === 'CHANGE_USER_PAGE') {
                  return Object.assign({}, state, action.page);
                }
                return state;
            },
            condition: (state = GroupManageModel.state.condition, action) => {
                if (action.type === 'CHANGE_CONDITION') {
                    const {key, value} = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
            newGroupData: (state = GroupManageModel.state.newGroupData, action) => {
                if (action.type === 'CHANGE_NEW_GROUP_DATA') {
                    const {key, value} = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
            editGroupData: (state = GroupManageModel.state.editGroupData, action) => {
                if (action.type === 'CHANGE_EDIT_GROUP_DATA') {
                    const {key, value} = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
            userList: (state = GroupManageModel.state.userList, action) => {
                if (action.type === 'CHANGE_USER_LIST') {
                    const {key, value} = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
            uList: (state = GroupManageModel.state.uList, action) => {
                if (action.type === 'CHANGE_U_LIST') {
                    return [...action.list];
                }
                return state;
            },
            newPerCondition: (state = GroupManageModel.state.newPerCondition, action) => {
                if (action.type === 'CHANGE_NEW_PER_CONDITION') {
                    const {key, value} = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
            editParentGroupData: (state = GroupManageModel.state.editParentGroupData, action) => {
                if(action.type === 'CHANGE_PARENT_EDIT_GROUP_DATA'){
                    const {key, value} = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
        }
    }
}();

export default GroupManageModel;


// WEBPACK FOOTER //
// ./src/models/GroupManageModel.js